import { Schema, model } from "mongoose";

/**
 * One chat message, stored on our own server.
 *
 * The sender is recorded two ways on purpose:
 *   senderId      — the permanent reference. Survives renames.
 *   senderName /  — a SNAPSHOT of how they were known when they sent it.
 *   senderAddress   Means rendering a conversation needs no lookups, and old
 *                   messages keep reading correctly even after someone leaves.
 *
 * That duplication is deliberate, not an oversight: it is what stops history
 * breaking when a mailbox is deleted.
 */
const messageSchema = new Schema(
  {
    conversationId: { type: Schema.Types.ObjectId, required: true },

    senderId: { type: Schema.Types.ObjectId, required: true },
    senderAddress: { type: String, required: true },
    senderName: { type: String, required: true },

    body: { type: String, required: true, maxlength: 8000 },

    /** MailboxUser ids who have seen it — small, since chats are per-domain. */
    readBy: [{ type: Schema.Types.ObjectId }],

    editedAt: { type: Date, default: null },
    deletedAt: { type: Date, default: null },

    sentAt: { type: Date, default: Date.now },
  },
  { timestamps: true }
);

messageSchema.index({ conversationId: 1, sentAt: -1 });
messageSchema.index({ conversationId: 1, readBy: 1 });

export const Message = model("Message", messageSchema);
